// extracted by mini-css-extract-plugin
module.exports = {"form":"contact-form-module--form--1kwEl","input":"contact-form-module--input--2lMAc","fields":"contact-form-module--fields--_z1hy","col":"contact-form-module--col--1wtoR"};